import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { createNewGroup, modifyGroup } from "../common/slices/group";
import { selectActive } from "../common/slices/location";
import { BlackButton, ButtonBase, LightButton } from "./Buttons";
import FormSelectCrewMember from "./FormSelectCrewMember";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P, Pmb } from "./Typography";
import { ErrorContext } from "../ErrorContext";
import FormCheckbox from "./FormCheckbox";

const marshall = (input, locationId) => ({
    division: false,
    ...input,
    locationId,
    crewMemberIds: input?.members?.map(cm => ({ value: cm.id, label: `${cm.active ? '' : '(x) '}${cm.name}` })),
})

const unmarshall = (input) => ({
    ...input,
    crewMemberIds: input.crewMemberIds?.map(cm => cm.value),
})

const ModalEditGroup = ({ group, onClose }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const locationId = useSelector(selectActive);
    const formValues = marshall(group, locationId);

    const {
        control,
        formState: { errors, isSubmitting, isValid },
        handleSubmit
    } = useForm({
        values: { ...formValues },
    })

    const formProps = { control, errors, locationId }

    const onSave = async (data) => {
        try {
            data.id ?
                await dispatch(modifyGroup(unmarshall(data))) :
                await dispatch(createNewGroup(unmarshall(data)))
            onClose();
        } catch (ex) {
            console.log(ex);
            errorContext.setError({ errorMessage: "Failed to save group", forSupport: ex.message })
        }
    }

    return (
        <Modal show size="60%" zindex='1200'>
            <Row>
                <H1>{group?.id ? "Edit" : "Create"} Group</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <Pmb>Group Details</Pmb>
            <P>Use the form below to create or edit a group of users.  Groups can be used to simplify the reporting or the creation of timesheets.</P>
            <Row>
                <FormTextInput {...formProps} name="name" label="Group Name" placeholder="Enter group name" rules={{ required: true }} />
                <FormCheckbox {...formProps} name="division" label="Division" placeholder="Convert group to division" />
            </Row>
            <FormSelectCrewMember showAll {...formProps} isMulti name="crewMemberIds" label="Crew Members" placeholder="Select crew members" rules={{ required: true }} />

            <Row>
                <BlackButton onClick={handleSubmit(onSave)} disabled={isSubmitting || !isValid}>Save</BlackButton>
                <LightButton onClick={onClose} disabled={isSubmitting}>Cancel</LightButton>
            </Row>
        </Modal>
    );
};

export default ModalEditGroup;
